import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import Breadcrumb from '../components/Breadcrumb';
import OrganizationsTable from '../components/OrganizationsTable';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const OrganizationsDemoPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Demo" />
      <div className="dashboard-main active">
        <div className="container-fluid">
          <OrganizationsTable status="demo" />
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </MasterLayout>
  );
};

export default OrganizationsDemoPage;

